import { render, staticRenderFns } from "./NuevoEntrada.vue?vue&type=template&id=6dc3f6d8&scoped=true"
import script from "./NuevoEntrada.vue?vue&type=script&lang=js"
export * from "./NuevoEntrada.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./NuevoEntrada.vue?vue&type=style&index=1&id=6dc3f6d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc3f6d8",
  null
  
)

export default component.exports